var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import "../types.js";
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { EntityFactory } from "../../entity/EntityFactory.js";
import { O as OwnerSchema } from "../../Owner-4cb1d33a.js";
import { D as DestroyOnTimeoutSchema, M as MultiDestroyOnTimeoutSchema } from "../../DestroyOnTimeoutComponent-72b9efed.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
import "../../constants/index.js";
import "../../loader/AssetLoader.js";
import "../../loader/ImageLoader.js";
import "pixi.js";
import "../../loader/SpriteLoader.js";
import "../../loader/PixiSpriteLoader.js";
import "../../loader/MapLoader.js";
import "../../utils/colors.js";
import "../../utils/sharedFetch.js";
import "../../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../../persist/persist.js";
import "../../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../../loader/SoundLoader.js";
import "../../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "lodash";
import "../../Parent-b4f1af10.js";
import "../core/ListenEntityCreation.js";
import "../entity/Spawn.js";
class DestroyOnTimeoutSystem {
  constructor() {
    __publicField(this, "type", "DestroyOnTimeout");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", DestroyOnTimeoutSchema);
    __publicField(this, "depth", DEPTHS.HEALTH + 1);
  }
  run(entity, gameModel) {
    const data = gameModel.getTypedUnsafe(entity, DestroyOnTimeoutSchema);
    updateTimeout(entity, data, gameModel);
  }
}
registerSystem(DestroyOnTimeoutSystem);
function updateTimeout(entity, timeout, gameModel) {
  timeout.timeElapsed += gameModel.dt(entity);
  if (timeout.timeElapsed > timeout.timeout) {
    if (timeout.spawnOnTimeout.length > 0) {
      let owner = entity;
      if (gameModel.hasComponent(entity, "Owner")) {
        owner = gameModel.getTypedUnsafe(entity, OwnerSchema).owner ?? entity;
      }
      timeout.spawnOnTimeout.forEach((spawn) => {
        const spawnedEntity = EntityFactory.getInstance().generateEntity(gameModel, spawn.description, {
          SourceStats: {
            damageAmount: 0,
            source: entity,
            owner
          }
        });
        if (spawn.overrideComponents.length > 0) {
          for (let i = 0; i < spawn.overrideComponents.length; i++) {
            const override = spawn.overrideComponents[i];
            if (override.type === "SourceStats") {
              gameModel.addComponent(spawnedEntity, override.type, {
                damageAmount: 0,
                source: entity,
                owner
              });
            } else {
              let overrideData = override.data;
              if (override.inherit) {
                overrideData = { ...gameModel.getComponent(spawnedEntity, override.type), ...overrideData ?? {} };
              }
              gameModel.addComponent(spawnedEntity, override.type, overrideData);
            }
          }
        }
      });
    }
    if (timeout.component !== "") {
      gameModel.removeComponent(entity, timeout.component);
      if (timeout.applyOnTimeout.length > 0) {
        timeout.applyOnTimeout.forEach((apply) => {
          gameModel.addComponent(entity, apply.type, apply.data);
        });
      }
    } else {
      if (timeout.applyOnTimeout.length > 0) {
        timeout.applyOnTimeout.forEach((apply) => {
          gameModel.addComponent(entity, apply.type, apply.data);
        });
      } else {
        gameModel.removeEntity(entity);
      }
    }
  }
}
class MultiDestroyOnTimeoutSystem {
  constructor() {
    __publicField(this, "type", "MultiDestroyOnTimeout");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", MultiDestroyOnTimeoutSchema);
    __publicField(this, "depth", DEPTHS.HEALTH + 1);
  }
  run(entity, gameModel) {
    const data = gameModel.getTypedUnsafe(entity, MultiDestroyOnTimeoutSchema);
    for (let i = 0; i < data.timeouts.length; ++i) {
      const timeout = data.timeouts[i];
      updateTimeout(entity, timeout, gameModel);
    }
    if (data.timeouts.length === 0) {
      gameModel.removeComponent(entity, "MultiDestroyOnTimeout");
    }
  }
}
registerSystem(MultiDestroyOnTimeoutSystem);
const addToDestroyOnTimeout = (entity, component, timeout, gameModel, spawnOnTimeout = [], applyOnTimeout = []) => {
  if (!gameModel.hasComponent(entity, "DestroyOnTimeout")) {
    gameModel.addComponent(entity, "DestroyOnTimeout", {
      component: component || "",
      timeout,
      timeElapsed: 0
    });
    return;
  }
  const dotData = gameModel.getTypedUnsafe(entity, DestroyOnTimeoutSchema);
  if (dotData.component === component) {
    dotData.timeout = timeout;
    dotData.timeElapsed = 0;
    return;
  }
  if (!gameModel.hasComponent(entity, "MultiDestroyOnTimeout")) {
    gameModel.addComponent(entity, "MultiDestroyOnTimeout", {
      timeouts: [
        {
          component,
          timeout,
          timeElapsed: 0
        }
      ]
    });
    return;
  }
  const data = gameModel.getTypedUnsafe(entity, MultiDestroyOnTimeoutSchema);
  const prevIndex = data.timeouts.findIndex((t) => t.component === component);
  if (prevIndex === -1) {
    const destroyOnTimeout = {
      component: component || "",
      timeout,
      timeElapsed: 0,
      spawnOnTimeout,
      applyOnTimeout
    };
    data.timeouts.push(destroyOnTimeout);
  } else {
    data.timeouts[prevIndex].timeout = timeout;
    data.timeouts[prevIndex].timeElapsed = 0;
  }
};
export {
  addToDestroyOnTimeout
};
//# sourceMappingURL=DestroyOnTimeoutComponent.js.map
